import { useCallback } from 'react';
import { useCart } from '@/lib/cart-store';
import { useCartUi } from './cart-ui-store';
export function useTriggerAddToCart() {
    const { add } = useCart();
    const triggerFlyTo = useCartUi((s) => s.triggerFlyTo);
    return useCallback((item, sourceEl) => {
        add(item);
        if (sourceEl && item.imageUrl) {
            const rect = sourceEl.getBoundingClientRect();
            triggerFlyTo(rect, item.imageUrl);
        }
    }, [add, triggerFlyTo]);
}
